import _ from 'underscore';

import BackboneReviewModel from 'pages/open-course/peerReview/reviewTypes/structured/models/review';

import type { SocialProfile } from 'bundles/assess-common/types/SocialProfile';
import type { ReviewMetadata } from 'bundles/peer/types/Reviews';

export default ({
  reviews,
  userProfiles,
}: {
  reviews: Array<ReviewMetadata>;
  userProfiles: Array<SocialProfile>;
  // @ts-expect-error ts-migrate(2749) FIXME: 'BackboneReviewModel' refers to a value, but is be... Remove this comment to see the full error message
}): Array<BackboneReviewModel> => {
  return reviews.map(function (reviewData) {
    return new BackboneReviewModel(
      Object.assign({}, reviewData, reviewData.definition, {
        creator: _(userProfiles).findWhere({ userId: reviewData.creatorId }),
      }),
      { parse: true }
    );
  });
};
